import api from "../../../services/api";

// Camada de acesso às rotas de configuração da Central de Alertas.
// Cada função é um wrapper fino; o tratamento de erro/snackbar fica na tela.

// --- Parâmetros globais (aba Parâmetros) ---
export async function getParametrosCentral() {
	const { data } = await api.get("/interno/centralAlertas/parametros");
	return data; // { janelaCorrelacaoMinutos, persistido, padraoAmbiente, limites }
}

export async function salvarParametrosCentral(parametros) {
	const { data } = await api.post(
		"/interno/centralAlertas/parametros",
		parametros
	);
	return data;
}

// --- Categorias inteligentes (aba Inteligentes) ---
export async function getCategoriasInteligentes() {
	const { data } = await api.get(
		"/interno/centralAlertas/categoriasInteligentes"
	);
	return data; // { categorias, janelaCorrelacaoMinutos, limites, severidades }
}

// Salva UMA categoria por chave; devolve o mesmo shape do get (estado inteiro).
export async function salvarCategoriaInteligente(categoria) {
	const { data } = await api.post(
		"/interno/centralAlertas/categoriasInteligentes",
		categoria
	);
	return data;
}

// --- Exibição (tipos + exceções) ---
export async function getVisibilidade() {
	const { data } = await api.get("/interno/centralAlertas/visibilidade");
	return data; // { tipos, excecoes }
}

export async function getTiposAlerta() {
	const { data } = await api.get("/interno/centralAlertas/tiposAlerta");
	return data; // TipoAlerta[]
}

export async function salvarTipoAlerta(tipo) {
	const { data } = await api.post("/interno/centralAlertas/tiposAlerta", tipo);
	return data;
}

export async function salvarExcecao(excecao) {
	const { data } = await api.post(
		"/interno/centralAlertas/visibilidade",
		excecao
	);
	return data;
}

export async function removerExcecao(id) {
	const { data } = await api.delete(
		`/interno/centralAlertas/visibilidade/${id}`
	);
	return data;
}

export async function getTriggersDisponiveis(hostId) {
	const { data } = await api.get(
		"/interno/centralAlertas/triggersDisponiveis",
		{ params: { hostId } }
	);
	return data; // [{ triggerid, descricao, prioridade, severidade, habilitado }]
}

// --- Automações ---
export async function getAutomacoes() {
	const { data } = await api.get("/interno/centralAlertas/automacoes");
	return data;
}

export async function salvarAutomacao(automacao) {
	const { data } = await api.post(
		"/interno/centralAlertas/automacoes",
		automacao
	);
	return data;
}

export async function removerAutomacao(id) {
	const { data } = await api.delete(
		`/interno/centralAlertas/automacoes/${id}`
	);
	return data;
}

export async function testarAutomacao(payload) {
	const { data } = await api.post(
		"/interno/centralAlertas/automacoes/testar",
		payload
	);
	return data;
}

export async function getExecucoesAutomacao(automacaoId) {
	const { data } = await api.get(
		`/interno/centralAlertas/automacoes/${automacaoId}/execucoes`
	);
	return data; // { automacao, execucoes }
}

// --- Auxiliares (dropdowns) ---
export async function getClientes() {
	const { data } = await api.get("/interno/getClients");
	return data;
}

// Serviços ATIVOS do cliente no ERP (mesma rota dos modais de ticket;
// includeInactive fica no default false). [{ id_cliente_servico, nome, status }]
// `clienteId` identifica o cliente (e o ERP dele) quando o mesmo código existe
// em mais de um ERP.
export async function getServicosDoCliente(clienteErpId, clienteId) {
	const { data } = await api.post("/interno/find/allServiceClient", {
		idClienteErp: String(clienteErpId),
		clienteId: clienteId || undefined,
	});
	return data;
}

export async function getHostsDoCliente(clienteId) {
	const { data } = await api.post("/interno/findMany/hostsCliente", {
		clienteId,
	});
	return data; // [{ hostId, ... }]
}

// Todos os hosts do Zabbix (para resolver hostId -> nome). Igual ao padrão de
// perfil/hostsConfig e createUpdateAgendamentoInterno/HostsAndSettings.
export async function getTodosHosts() {
	const { data } = await api.post("/zabbix/hostList", {});
	return data; // [{ hostid, host, name }]
}

// Listas do ERP para os parâmetros do ticket (mesma rota dos modais de novo
// atendimento): HubSoft -> tipoAtendimento/statusAtendimento/origemContato/
// userResponsaveis; IXC -> filiais/assuntos/departamentos/prioridades/status/horarios.
// `erpId`: ERP da regra (sem ERP cadastrado: a variável ERP).
export async function getParamsNewTicket(erpId) {
	const { data } = await api.post("/interno/find/paramsNewTicket", {
		erpId: erpId || undefined,
	});
	return data;
}

// IXC: colaboradores de um departamento/setor (para responsavelId).
export async function getFuncionarios(idSetor, erpId) {
	const { data } = await api.post("/interno/find/funcionarios", {
		idSetor,
		isOs: false,
		erpId: erpId || undefined,
	});
	return data; // [{ id, funcionario }]
}
